import PropTypes from 'prop-types'

import { MultiSelect } from 'primereact/multiselect'
import MultiSelectHeader from 'primereact-raytm-theme/MultiSelectHeader'
import MultiSelectFooter from 'primereact-raytm-theme/MultiSelectFooter'

import style from '@aytm/app/stats/page/question-views/components/controls/styles/Controls.module.scss'
import mnStyle from '@aytm/app/stats/page/question-views/mn/components/controls/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

const deliveryLabel = ({ value = [], options = [] }) => {
  // nothing selected — prompt the user to pick an option instead of an empty label
  if (value.length === 0) return <span>No delivery option selected</span>
  if (value.length === options.length) return <span>All delivery options</span>
  const selectedLabels = options.filter(option => value.includes(option.value)).map(option => option.text)
  return <span>{selectedLabels.join(', ')}</span>
}

const DeliveryControls = ({ value, options, disabled, onChange }) => (
  <div className={`${style.component} ${mnStyle.delivery} ${NO_PRINT}`}>
    <span className={`p-field ${mnStyle.label}`}>Delivery options</span>
    <div className={`p-fluid ${mnStyle.dropdown}`}>
      <MultiSelect
        className="p-multiselect-rounded"
        placeholder="All delivery options"
        value={value}
        options={options}
        optionValue="value"
        optionLabel="text"
        buttonLabelTemplate={deliveryLabel}
        panelHeaderTemplate={MultiSelectHeader}
        panelFooterTemplate={MultiSelectFooter}
        disabled={disabled}
        onChange={event => onChange(event.value)}
      />
    </div>
    <span className="p-right">
      <small>Filter results by selected delivery options</small>
    </span>
  </div>
)

DeliveryControls.propTypes = {
  value: PropTypes.array,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string
    })
  ),
  disabled: PropTypes.bool,
  onChange: PropTypes.func
}

DeliveryControls.displayName = 'DeliveryControls'

export default DeliveryControls
